import { Controller } from "@hotwired/stimulus";
import { nextFrame } from "../helpers/timing_helpers";

// Connects to data-controller="video-poster"
export default class extends Controller {
  static values = { url: String };

  async connect() {
    await nextFrame();

    if (this.hasUrlValue) this.element.poster = this.urlValue;
    if (!this.element.hasAttribute("preload")) this.element.preload = "none";
  }
}
